// Posts a form payload to the backend, attaching the current page as source_page.
export async function postForm(endpoint, body) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...body, source_page: window.location.pathname }),
  });
  let data = {};
  try { data = await res.json(); } catch (_) { /* ignore */ }
  if (!res.ok) {
    throw new Error(typeof data.detail === "string" ? data.detail : "Something went wrong. Please try again.");
  }
  return data;
}
